import { FC, ReactNode } from 'react';

import { StyledCreateVideo } from './styled';

interface IProps {
  title: string;
  children: ReactNode;
}

const CreateItem: FC<IProps> = ({ title, children }) => (
  <StyledCreateVideo>
    <h4 className="create-new-title">{title}</h4>
    <div className="create-new-content">{children}</div>
  </StyledCreateVideo>
);

export default CreateItem;
